// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-config-form {
  width: 100%;
}

.mobile-config-heading {
  margin-right: 5px;
  padding-left: 5px;
}

.table-container {
  height: 10px;
}

.form-container {
  overflow-y: scroll;
  overflow-x: hidden;
  margin: -2px;
}

.primary {
  margin-left: 5px;
}

.secondary {
  margin-right: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
